export default {
    namespaced: true,

    state: {
        questions: [],
        availableAreas: [],
        savedAreas: [],
    },

    getters: {
        hasQuestions: (state) => {
            return state.questions.length;
        },
    },

    actions: {
        getQuestions({ commit }) {
            return axios.get('/api/leads/questions')
            .then((response) => {
                commit('setQuestions', response.data.data);
            });
        },
        saveAnswer({ commit }, params) {
            return axios.post(`/api/leads/questions/${params.leadQuestionPK}/answer`, {
                answer: params.answer,
            });
        },
        getAvailableAreas({ commit }) {
            return axios.get('/api/leads/available-areas')
            .then((response) => {
                commit('setAvailableAreas', response.data.data);
            });
        },
        getSavedAreas({ commit }) {
            return axios.get('/api/leads/saved-areas')
            .then((response) => {
                commit('setSavedAreas', response.data.data);
            });
        },
        saveSelectedAreas({ commit }, areas) {
            return axios.post('/api/leads/areas', {
                areas: areas,
            });
        },
    },
    mutations: {
        setQuestions(state, questions) {
            state.questions = questions;
        },
        setAvailableAreas(state, areas) {
            state.availableAreas = areas;
        },
        setSavedAreas(state, areas) {
            state.savedAreas = areas;
        },
    },
};